export const TIPOS_DESTINATARIOS = {
  CO: "Compradores",
  CC: "Cônjuges dos Compradores",
  VD: "Vendedores",
  CV: "Cônjuges dos Vendedores",
  AG: "Agência",
  PA: "Parceiro",
  OU: "Outros",
};
